module.exports = __webpack_public_path__ + "static/media/HeaderLight.28fef462.svg";